<template>
	<div>
		<h1>Terem kiválasztása</h1>
		<v-row>
			<v-col cols="12" sm="2">
				<v-menu
				    v-model="hetfovalaszto.menu"
				    :close-on-content-click="false"
				    transition="scale-transition"
				    offset-y
				    min-width="290px"
				  >
				    <template v-slot:activator="{ on, attrs }">
				      <v-text-field
				        v-model="hetfovalaszto.datum"
				        label="Hét kezdőnapja"
				        prepend-inner-icon="fa-calendar"
				        readonly
				        v-bind="attrs"
				        v-on="on"
				      ></v-text-field>
				    </template>
				    <v-date-picker
				      v-model="hetfovalaszto.datum"
				      no-title
				      scrollable
						  :allowed-dates="hetfok"
							first-day-of-week="1"
							@input="hetfovalaszto.menu=false, tablazatfrissitese()"
				    >
				    </v-date-picker>
			  </v-menu>
			</v-col>
		</v-row>
		<v-data-table
			:items="bejegyzettszilenciumok"
			:headers="fejlecek"
			disable-pagination
			hide-default-footer
		>
			<template v-slot:item.nap="{item}">
				{{item.nap.replaceAll('-','.')}} - {{(new Date(item.nap)).getDay()==1?"Hétfő":((new Date(item.nap)).getDay()==2?"Kedd":((new Date(item.nap)).getDay()==3?"Szerda":"Csütörtök"))}}
			</template>
			<template v-slot:item.szilencium="{item}">
				{{szilencium(item.szilenciumid)}}
			</template>
			<template v-slot:item.terem="{item}">
				<v-select
					prepend-inner-icon="fa-chalkboard-teacher"
					rounded
					outlined
					label="Terem"
					:items="teremSelect(item.szilenciumid,item.nap)"
					v-model="item.teremid"
					:readonly="!modosithato||item.diakmodosithatja==0"
					@change="teremModositasa(item.szilenciumid,item.nap,$event)"
				/>
			</template>
		</v-data-table>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>

</template>

<script>
	export default {
    props: ['nevelo', 'diakId'],
		data: function(){
			return {
				tablazatmutat: false,
				snackbar: {
					megnyit: false,
					szoveg: ""
				},
				hetfovalaszto: {
					menu: false,
					datum: this.aktualishetfo()
				},

				bejegyzettszilenciumok: [],
				szilenciumok: [],
				termek: [],
				modosithato: false,
				"terem-szilencium": [],
				telitettseg: [],
				fejlecek: [
					{
						text: 'Nap',
						value: 'nap',
						align: 'center',
						filterable: false,
						sortable: false,
						groupable: false
					},
					{
						text: 'Szilencium',
						value: 'szilencium',
						align: 'center',
						filterable: false,
						sortable: false,
						groupable: false
					},
					{
						text: 'Terem',
						value: 'terem',
						align: 'center',
						filterable: false,
						sortable: false,
						groupable: false
					}
				]

			}
		},
		computed: {

		},
		watch: {

		},
		methods: {
			teremModositasa: function(szilenciumid, nap, teremid) {
				this.axios.post(this.$store.state.backendeleres+(this.nevelo?"":`teremvalasztas/kollegista`), {szilenciumid, nap, teremid}).then((response) => {
					if(response.data.bejelentkezve==false) this.kijelentkezes;
					if(response.data.ok) {
						this.snackbar.szoveg="A terem kiválasztása sikerült";
					}
					else {
						this.snackbar.szoveg="A terem kiválasztása nem sikerült: "+response.data.hiba
						this.tablazatfrissitese();
					}
					this.snackbar.megnyit=true;
				})
			},
			teremSelect: function(szilenciumid,nap) {
				return this.termek.filter(t => this["terem-szilencium"].findIndex(tsz => tsz.teremid==t.id&&tsz.szilenciumid==szilenciumid)!=-1).map(t => {
					const telitettseg = this.telitettseg.find(teli => teli.teremid==t.id&&teli.nap==nap&&teli.szilenciumid==szilenciumid)
					return {
						value: t.id,
						text: `${t.nev} (${telitettseg? telitettseg.telitettseg:0}/${t.ferohely})`,
						disabled: telitettseg?telitettseg.telitettseg>=t.ferohely:0>=t.ferohely
					}
				})
			},
			szilencium: function(sziloid) {
				const szilo = this.szilenciumok.find(sz => sz.id==sziloid);
				return `${szilo.szam}. szilencium (${szilo.idopont})`
			},
			tablazatfrissitese: function() {
        this.axios.get(this.nevelo ? this.$store.state.backendeleres+"teremvalasztas/nevelotanar/"+this.diakId+"/"+this.hetfovalaszto.datum:this.$store.state.backendeleres+"teremvalasztas/kollegista/"+this.hetfovalaszto.datum)
                  .then((response) => {
                    if(response.data.bejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) {
											this.bejegyzettszilenciumok = response.data.adatok.bejegyzettszilenciumok;
											this.szilenciumok = response.data.adatok.szilenciumok;
											this.termek = response.data.adatok.termek;
											this["terem-szilencium"] = response.data.adatok["terem-szilencium"];
											this.telitettseg = response.data.adatok.telitettseg
											this.modosithato = response.data.adatok.modosithato;
										}
                  })
			},
			aktualishetfo: () => {var d = new Date(); var r = new Date(d.setDate(d.getDate()-d.getDay()+(d.getDay() == 0 ? -6:1))); return r.toISOString().substring(0,10)},
			hetfok: nap => new Date(Date.parse(nap)).getDay()==1,
			hettetszolegesnapja: function(nap /*0: hétfő, 1: kedd*/)  {
				var datum = new Date(Date.parse(this.hetfovalaszto.datum))
				datum.setDate(datum.getDate()+nap)
				return datum.toISOString().substring(0,10)
			}
		},
		mounted(){
			this.tablazatfrissitese()
		}
	}
</script>
